import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconFlagSp = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 512 512" size={size}>
      <g>
        <rect fill="#B5002A" height="298.7" width="512" y="106.7" />
        <rect fill="#F4C327" height="149.4" width="512" y="181.3" />
      </g>
    </BaseIcon>
  );
}

export default IconFlagSp;